import { render } from "./DemoComponentCard.vue?vue&type=template&id=02a5aabe"
import script from "./DemoComponentCard.vue?vue&type=script&lang=js"
export * from "./DemoComponentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__